import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const ProductSizeSchema = (localeCodes, isEdit = false) => Yup.object().shape({
  code: Yup
    .string()
    .label("Code")
    .required()
    .max(50),
  label: Yup
    .string()
    .label("Label")
    .required()
    .max(100),
  localizations: createLocalizationsSchema(localeCodes),
});

export default ProductSizeSchema;
